var map = {
	"./chokwin_footer.svg": [
		14472,
		14472
	],
	"./luckykingbet_footer.svg": [
		22503,
		22503
	],
	"./mars-br_footer.svg": [
		93722,
		93722
	],
	"./mars-mx_footer.svg": [
		27576,
		27576
	],
	"./mars-pt_footer.svg": [
		28301,
		28301
	],
	"./mars-ru_footer.svg": [
		77806,
		77806
	],
	"./mars-th_footer.svg": [
		49896,
		49896
	],
	"./mars_footer.svg": [
		57692,
		57692
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 56783;
module.exports = webpackAsyncContext;